<div class="dropdown" *ngIf="!StandAloneButton">
  <button class="btn btn-primary dropdown-toggle btn-sm " type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <i class="fa-solid fa-paper-plane "></i>
    Send Email
  </button>
  <ul class="dropdown-menu">
    <!-- Show skeleton while loading -->
    <ng-container *ngIf="isLoading">
      <li *ngFor="let i of [1,2,3,4]" class="px-2 py-1">
        <ngx-skeleton-loader appearance="line"
          [theme]="{ height: '12px', 'margin-bottom': '0.5rem', 'border-radius': '4px' }">
        </ngx-skeleton-loader>
      </li>
    </ng-container>

    <!-- Show actual items when loaded -->
    <ng-container *ngIf="!isLoading">
      <li *ngFor="let template of EmailList" (click)="openModal(template)">
        <a class="dropdown-item">{{ template.tName }}</a>
      </li>
    </ng-container>
  </ul>
</div>


<div *ngIf="StandAloneButton">
  <button class="btn btn-primary " type="button" (click)="openModal(StandAloneTemplateData)">
    <i class="fa-solid fa-paper-plane "></i>
    Send Email
  </button>
</div>




<ng-template #SendEmailForm>

  <div class="modal-header">
    <h6 class="modal-title mb-0">
      {{ EmailForm.value.tName }}
    </h6>

    <div class="d-flex align-items-center gap-2">
      <!-- Edit (Pencil) Button -->
      <button type="button" class="btn btn-sm" title="Edit" (click)="isUniversalEditing= !isUniversalEditing">
        <i class="bi bi-pencil text-light"></i>
      </button>

      <!-- Close Button -->
      <button type="button" class="btn-close btn-close-white" aria-label="Close"
        (click)="addSendModel.close()"></button>
    </div>
  </div>


  <div class="modal-body ">
    <form [formGroup]="EmailForm">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mb-1">
            <label class="form-label">From</label>

            <ng-select [items]="emailConfigList" bindValue="emailConfigId" bindLabel="iName"
              [formControl]="EmailForm.controls.emailConfigId"></ng-select>
            <app-form-errors [control]="EmailForm.controls.emailConfigId"></app-form-errors>
          </div>

          <!-- Email Info-->
          <div class="col-md-6 mb-1">
            <label class="form-label">Email TO<span style="color: red;">*</span></label>
            <input type="email" class="form-control form-control-sm" [formControl]="EmailForm.controls.emailTO" />
            <app-form-errors [control]="EmailForm.controls.emailTO"></app-form-errors>
          </div>

          <div class="col-md-6 mb-1">
            <label class="form-label">CC TO</label>
            <input type="email" class="form-control form-control-sm" [formControl]="EmailForm.controls.ccTo" />
            <app-form-errors [control]="EmailForm.controls.ccTo"></app-form-errors>
          </div>

          <div class="col-md-6 mb-1">
            <label class="form-label">BCC TO</label>
            <input type="email" class="form-control form-control-sm" [formControl]="EmailForm.controls.bccTo" />
            <app-form-errors [control]="EmailForm.controls.bccTo"></app-form-errors>
          </div>


          <div class="d-flex align-items-end gap-2 mb-2">
            <div class="flex-grow-1">

              <label class="form-label">Subject</label>
              <input type="email" class="form-control form-control-sm" [formControl]="EmailForm.controls.aSubject" />
              <app-form-errors [control]="EmailForm.controls.aSubject"></app-form-errors>
            </div>


            <div>
              <button class="btn btn-sm btn-primary " (click)="onSubmitAction()">Send</button>
            </div>
          </div>

          <div class="col-md-12 mb-3">
            <label>Attachments</label>
            <input type="file" class="form-control form-control-sm" (change)="onAttachmentSelected($event)" multiple />
          </div>

          <!-- Email Variables Section -->
          <div class="mb-3">
            <label class="form-label">Email Variables<span style="color: red;">*</span></label>
            <div class="row" *ngFor="let variable of emailVariableList; let i = index">
              <!-- Variable instance -->
              <div class="col-6 mb-1">
                <input type="text" class="form-control form-control-sm" [value]="variable.varInstance" readonly />
              </div>
              <!-- User input -->
              <div class="col-6 mb-1">
                <input type="text" class="form-control form-control-sm" name="varValue{{i}}" placeholder="Enter value"
                  (input)="onVariableInput(variable, $event)" />
              </div>
            </div>

          </div>

          <!-- Template Body Section (Rich Text Editor or HTML View) -->
          <div class="mb-3">
            <div *ngIf="isUniversalEditing">
              <app-rich-text-editor [control]="EmailForm.controls.aBody"></app-rich-text-editor>
            </div>
            <div *ngIf="!isUniversalEditing"
              [innerHTML]="sanitizer.bypassSecurityTrustHtml(EmailForm.controls.aBody.value!)">
            </div>
          </div>
        </div>




      </div>


      <!-- Modal Footer -->
      <div class="modal-footer text-end">
        <button class="btn btn-sm btn-primary" [disabled]="EmailForm.invalid" (click)="onSubmitAction()">Send</button>
        <button class="btn btn-sm btn-secondary" (click)="addSendModel.close()">Close</button>
      </div>
    </form>
  </div>
</ng-template>